import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import "../styles/HighlightedProducts.css";

import vision from "../assets/vision_1.png";
import mission from "../assets/mission_1.png";

const products = [
  {
    title: "Our Vision",
    image: vision,
    description:
      "At Oxford Exports, we envision a world where energy trade is seamless, efficient, and sustainable.",
    link: "/aboutus#vision",
  },
  {
    title: "Our Mission",
    image: mission,
    description:
      "To facilitate seamless petroleum transactions, foster strong relationships, and drive growth for our clients and partners, while promoting a sustainable energy future.",
    link: "/aboutus#mission",
  },
];

export default function HighlightedProducts() {
  const navigate = useNavigate();

  const handleClick = (link) => {
    const [path, hash] = link.split("#");
    navigate(path); // Navigate to AboutUs page

    setTimeout(() => {
      if (hash) {
        const el = document.getElementById(hash);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 100); // Wait for AboutUs to render
  };

  return (
    <section className="highlighted-products">
      <div className="container">
        <h2 className="products-title">Patnering Your Success in Petroleum Sourcing</h2>

        <div className="zigzag-list">
          {products.map((item, index) => {
            const isReversed = index % 2 !== 0;

            return (
              <motion.div
                key={index}
                className={`product-card-horizontal ${
                  isReversed ? "reverse" : ""
                }`}
                initial={{
                  opacity: 0,
                  x: isReversed ? 80 : -80,
                }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, ease: "easeOut" }}
                viewport={{ once: true }}
              >
                <div className="product-image">
                  <img src={item.image} alt={item.title} />
                </div>

                <div className="product-content">
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                  <button
                    className="learn-more-btn"
                    onClick={() => handleClick(item.link)}
                  >
                    Learn More →
                  </button>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
